<h1 mat-dialog-title>{{ 'NAV.LOGOUT.TITLE' | translate }}</h1>
<div mat-dialog-content>
    {{ 'NAV.LOGOUT.YOU_SURE' | translate }}

</div>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ 'NAV.LOGOUT.NO' | translate }}</button>
    <button mat-button (click)="logout()" color='accent'>{{ 'NAV.LOGOUT.YES' | translate }}</button>
</mat-dialog-actions>
  